// This file hase been auto generated by "npm run transform:svgs" on 2024-07-11T07:12:13.653Z.
// Please read ./scripts/transform-svgs/README.md for more information.
export const SvgIconNames = [
    '3d-active',
    '3d',
    'adblue-active',
    'adblue-alert-active',
    'adblue-alert',
    'adblue',
    'add-active',
    'add-circle-active',
    'add-circle',
    'add',
    'address-book-active',
    'address-book',
    'administrator-active',
    'administrator',
    'air-filter-active',
    'air-filter-inside-active',
    'air-filter-inside',
    'air-filter',
    'air-suspension-active',
    'air-suspension',
    'announcements-active',
    'announcements',
    'anti-theft-alarm-system-active',
    'anti-theft-alarm-system-alert-active',
    'anti-theft-alarm-system-alert',
    'anti-theft-alarm-system',
    'apps-active',
    'apps',
    'arrow-down-active',
    'arrow-down',
    'arrow-left-light-active',
    'arrow-left-light',
    'arrow-left-normal-active',
    'arrow-left-normal',
    'arrow-left-sharp-active',
    'arrow-left-sharp',
    'arrow-left-u-turn-active',
    'arrow-left-u-turn',
    'arrow-right-light-active',
    'arrow-right-light',
    'arrow-right-normal-active',
    'arrow-right-normal',
    'arrow-right-sharp-active',
    'arrow-right-sharp',
    'arrow-right-u-turn-active',
    'arrow-right-u-turn',
    'arrow-straight-down-active',
    'arrow-straight-down',
    'arrow-straight-up-active',
    'arrow-straight-up',
    'arrow-up-active',
    'arrow-up',
    'audio-volume-active',
    'audio-volume',
    'audio-volume-off-active',
    'audio-volume-off',
    'aupeo-active',
    'aupeo',
    'back-active',
    'back',
    'battery-12v-active',
    'battery-12v',
    'battery-active',
    'battery-at-destination-active',
    'battery-at-destination',
    'battery-at-start-active',
    'battery-at-start',
    'battery-charge-active',
    'battery-charge',
    'battery',
    'battery-price-active',
    'battery-price',
    'blog-post-active',
    'blog-post',
    'bonnet-open-active',
    'bonnet-open',
    'bookmark-active',
    'bookmark',
    'brake-fluid-active',
    'brake-fluid',
    'brake-pad-active',
    'brake-pad-alert-active',
    'brake-pad-alert',
    'brake-pad',
    'break-active',
    'break',
    'brush-active',
    'brush',
    'business-address-active',
    'business-address',
    'business-customer-active',
    'business-customer',
    'calculator-active',
    'calculator',
    'calendar-events-active',
    'calendar-events',
    'camera-active',
    'camera',
    'cancel-active',
    'cancel',
    'car-active',
    'car-dimensions-active',
    'car-dimensions',
    'car-handover-active',
    'car-handover',
    'car-insurance-active',
    'car-insurance',
    'car',
    'car-search-active',
    'car-search',
    'catalogue-active',
    'catalogue',
    'caution-active',
    'caution',
    'charge-level-active',
    'charge-level',
    'charging-active',
    'charging',
    'charging-plate-active',
    'charging-plate',
    'charging-station-active',
    'charging-station',
    'city-active',
    'city',
    'climate-active',
    'climate-auto-active',
    'climate-auto',
    'climate-electric-active',
    'climate-electric',
    'climate',
    'clothing-active',
    'clothing',
    'co2-emission-active',
    'co2-emission',
    'code-active',
    'code',
    'collapsed-tabs-active',
    'collapsed-tabs',
    'commute-active',
    'commute',
    'compare-active',
    'compare',
    'compass-active',
    'compass',
    'connect-key-active',
    'connect-key',
    'consumption-active',
    'consumption',
    'content-activities-active',
    'content-activities',
    'copy-active',
    'copy',
    'country-active',
    'country',
    'credit-card-active',
    'credit-card',
    'cross-traffic-assist-rear-active',
    'cross-traffic-assist-rear',
    'cubic-capacity-active',
    'cubic-capacity',
    'damper-active',
    'damper',
    'dashboard-active',
    'dashboard',
    'dealer-request-active',
    'dealer-request',
    'dealer-search-active',
    'dealer-search',
    'delivery-active',
    'delivery',
    'diagnostics-active',
    'diagnostics',
    'direct-mail-active',
    'direct-mail',
    'discussion-active',
    'discussion',
    'display-active',
    'display',
    'distance-active',
    'distance',
    'document-pdf-active',
    'document-pdf',
    'document-pricelist-dollar-active',
    'document-pricelist-dollar',
    'document-pricelist-euro-active',
    'document-pricelist-euro',
    'document-taxation-active',
    'document-taxation',
    'documents-active',
    'documents',
    'door-open-active',
    'door-open',
    'doors-closed-active',
    'doors-closed',
    'doors-open-all-active',
    'doors-open-all',
    'download-active',
    'download',
    'drive-belt-active',
    'drive-belt',
    'eco-cycle-active',
    'eco-cycle',
    'eco-friendly-active',
    'eco-friendly',
    'edit-active',
    'edit',
    'editorial-active',
    'editorial',
    'electric-range-active',
    'electric-range',
    'energy-green-active',
    'energy-green',
    'engine-active',
    'engine',
    'erase-active',
    'erase',
    'extended-warranty-active',
    'extended-warranty',
    'external-link-active',
    'external-link',
    'eye-active',
    'eye-crossed-active',
    'eye-crossed',
    'eye',
    'facebook',
    'factory-active',
    'factory',
    'favorite-active',
    'favorite',
    'feature-on-demand-active',
    'feature-on-demand',
    'feed',
    'filter-active',
    'filter',
    'financial-services-active',
    'financial-services',
    'first-aid-active',
    'first-aid',
    'flashlight-active',
    'flashlight',
    'follow-active',
    'follow',
    'forward-active',
    'forward',
    'fuel-range-active',
    'fuel-range',
    'fuel-station-active',
    'fuel-station',
    'gas-station-active',
    'gas-station',
    'geofence-active',
    'geofence-alert-active',
    'geofence-alert',
    'geofence',
    'gift-active',
    'gift',
    'google-plus',
    'gps-active',
    'gps',
    'grab-active',
    'grab',
    'group-discussion-active',
    'group-discussion',
    'groups-active',
    'groups',
    'handshake-active',
    'handshake',
    'help-circle-active',
    'help-circle',
    'history-active',
    'history',
    'home-active',
    'home',
    'honk-active',
    'honk-and-flash-active',
    'honk-and-flash',
    'honk',
    'hotline-active',
    'hotline',
    'idea-active',
    'idea',
    'indicators-active',
    'indicators',
    'info-circle-active',
    'info-circle',
    'inspection-active',
    'inspection',
    'instagram',
    'interior-configuration-active',
    'interior-configuration',
    'keyboard-active',
    'keyboard',
    'languages-active',
    'languages',
    'laptop-active',
    'laptop',
    'light-technology-active',
    'light-technology',
    'lights-crossed-active',
    'lights-crossed',
    'lights-day-active',
    'lights-day',
    'lights-dim-active',
    'lights-dim',
    'lights-full-beam-active',
    'lights-full-beam',
    'lights-led-active',
    'lights-led',
    'lights-xenon-active',
    'lights-xenon',
    'line-active',
    'line',
    'line-me',
    'linkedin',
    'list-active',
    'list',
    'lock-active',
    'lock',
    'lock-unlock-active',
    'lock-unlock',
    'logbook-active',
    'logbook',
    'login-active',
    'login',
    'logout-active',
    'logout',
    'loose-wheel-indicator-active',
    'loose-wheel-indicator',
    'main-user-active',
    'main-user',
    'maintenance-active',
    'maintenance',
    'maneuvering-assist-active',
    'maneuvering-assist',
    'map-layer-active',
    'map-layer',
    'merchandise-active',
    'merchandise',
    'microphone-off-active',
    'microphone-off',
    'microphone-on-active',
    'microphone-on',
    'mileage-active',
    'mileage',
    'mmi-active',
    'mmi',
    'mobile-phone-active',
    'mobile-phone',
    'more-active',
    'more',
    'motorway-active',
    'motorway',
    'my-dealer-active',
    'my-dealer',
    'myaudi-destinations-active',
    'myaudi-destinations',
    'napster',
    'network-active',
    'network',
    'news-active',
    'news',
    'nfc-active',
    'nfc-inactive-active',
    'nfc-inactive',
    'nfc',
    'notepad-active',
    'notepad',
    'off-canvas-active',
    'off-canvas',
    'offline-maps-active',
    'offline-maps',
    'oil-change-active',
    'oil-change',
    'options-active',
    'options',
    'order-reverse-active',
    'order-reverse',
    'over-the-air-active',
    'over-the-air-car-active',
    'over-the-air-car',
    'over-the-air',
    'package-active',
    'package',
    'paragraph-circle-active',
    'paragraph-circle',
    'parking-active',
    'parking-in-left-active',
    'parking-in-left',
    'parking-in-left-long-active',
    'parking-in-left-long',
    'parking-in-right-active',
    'parking-in-right',
    'parking-in-right-long-active',
    'parking-in-right-long',
    'parking-in-straight-active',
    'parking-in-straight',
    'parking',
    'parking-out-left-active',
    'parking-out-left',
    'parking-out-left-long-active',
    'parking-out-left-long',
    'parking-out-right-active',
    'parking-out-right',
    'parking-out-right-long-active',
    'parking-out-right-long',
    'parking-out-straight-active',
    'parking-out-straight',
    'pause-active',
    'pause',
    'photo-active',
    'photo',
    'photo-none-active',
    'photo-none',
    'piloted-parking-active',
    'piloted-parking',
    'pinterest',
    'plan-route-active',
    'plan-route',
    'play-active',
    'play',
    'plug-ccs-dc-active',
    'plug-ccs-dc',
    'plug-ccs1-active',
    'plug-ccs1',
    'plug-cee3-active',
    'plug-cee3',
    'plug-cee5-active',
    'plug-cee5',
    'plug-chademo-dc-active',
    'plug-chademo-dc',
    'plug-schuko-active',
    'plug-schuko',
    'plug-type1-ac-active',
    'plug-type1-ac',
    'plug-type2-ac-active',
    'plug-type2-ac',
    'poi-active',
    'poi-calendar-active',
    'poi-calendar',
    'poi-car-active',
    'poi-car',
    'poi-contact-active',
    'poi-contact',
    'poi-favorite-active',
    'poi-favorite',
    'poi-home-active',
    'poi-home',
    'poi',
    'poi-last-destination-active',
    'poi-last-destination',
    'poi-search-active',
    'poi-search',
    'poi-work-active',
    'poi-work',
    'pois-active',
    'pois',
    'polls-active',
    'polls',
    'power-active',
    'power',
    'power-solar-active',
    'power-solar',
    'power-water-active',
    'power-water',
    'power-wind-active',
    'power-wind',
    'pre-heating-active',
    'pre-heating',
    'print-active',
    'print',
    'privacy-mode-active',
    'privacy-mode',
    'private-customer-active',
    'private-customer',
    'profile-active',
    'profile',
    'projects-active',
    'projects',
    'public-transport-active',
    'public-transport',
    'quattro-active',
    'quattro',
    'rating-50-active',
    'rating-50',
    'rating-active',
    'rating',
    'raw-materials-active',
    'raw-materials',
    'receive-e-mail-notification-active',
    'receive-e-mail-notification',
    'recommended-destination-active',
    'recommended-destination',
    'refresh-active',
    'refresh',
    'remove-active',
    'remove-circle-active',
    'remove-circle',
    'remove',
    'replay-active',
    'replay',
    'resize-decrease-active',
    'resize-decrease',
    'resize-increase-active',
    'resize-increase',
    'restaurant-active',
    'restaurant',
    'restroom-active',
    'restroom',
    'results-list-active',
    'results-list',
    'roof-open-active',
    'roof-open',
    'rotate-device-active',
    'rotate-device',
    'rotate-image-left-active',
    'rotate-image-left',
    'rotate-image-right-active',
    'rotate-image-right',
    'rotate-left-active',
    'rotate-left',
    'rotate-right-active',
    'rotate-right',
    'roundabout-left-active',
    'roundabout-left',
    'roundabout-long-left-active',
    'roundabout-long-left',
    'roundabout-long-right-active',
    'roundabout-long-right',
    'roundabout-right-active',
    'roundabout-right',
    'roundabout-sharp-left-active',
    'roundabout-sharp-left',
    'roundabout-sharp-right-active',
    'roundabout-sharp-right',
    'roundabout-straight-active',
    'roundabout-straight',
    'search-active',
    'search',
    'select-active',
    'select-all-active',
    'select-all',
    'select-circle-active',
    'select-circle',
    'select',
    'send-active',
    'send',
    'send-to-vehicle-active',
    'send-to-vehicle',
    'service-package-active',
    'service-package',
    'settings-active',
    'settings',
    'share-active',
    'share-android-active',
    'share-android',
    'share',
    'shopping-basket-active',
    'shopping-basket',
    'shopping-basket-selected-active',
    'shopping-basket-selected',
    'shuffle-active',
    'shuffle',
    'side-assist-active',
    'side-assist',
    'signal-active',
    'signal',
    'skip-next-active',
    'skip-next',
    'skip-previous-active',
    'skip-previous',
    'slider-active',
    'slider',
    'smartwatch-active',
    'smartwatch',
    'smiley-happy-active',
    'smiley-happy',
    'smiley-neutral-active',
    'smiley-neutral',
    'smiley-unhappy-active',
    'smiley-unhappy',
    'snapchat',
    'snow-active',
    'snow',
    'social-reader-active',
    'social-reader',
    'spark-plug-active',
    'spark-plug',
    'special-circumstances-active',
    'special-circumstances',
    'special-offer-active',
    'special-offer',
    'split-active',
    'split',
    'status-update-active',
    'status-update',
    'stock-market-active',
    'stock-market',
    'sync-active',
    'sync',
    'sync-off-active',
    'sync-off',
    'tag-active',
    'tag',
    'test-drive-active',
    'test-drive',
    'thumbs-down-active',
    'thumbs-down',
    'thumbs-up-active',
    'thumbs-up',
    'time-active',
    'time-climate1-active',
    'time-climate1',
    'time-climate2-active',
    'time-climate2',
    'time',
    'time-long-active',
    'time-long',
    'time-middle-active',
    'time-middle',
    'time-short-active',
    'time-short',
    'tire-active',
    'tire-battery-active',
    'tire-battery',
    'tire',
    'tire-sealant-active',
    'tire-sealant',
    'top-speed-active',
    'top-speed',
    'torque-active',
    'torque',
    'tour-active',
    'tour',
    'traffic-active',
    'traffic',
    'traffic-sign-recognition-active',
    'traffic-sign-recognition-alert-active',
    'traffic-sign-recognition-alert',
    'traffic-sign-recognition',
    'trailer-maneuver-active',
    'trailer-maneuver',
    'train-active',
    'train',
    'training-active',
    'training',
    'transmission-active',
    'transmission',
    'trunk-open-active',
    'trunk-open',
    'tube-active',
    'tube',
    'upload-active',
    'upload',
    'used-car-search-active',
    'used-car-search',
    'used-cars-active',
    'used-cars',
    'user-active',
    'user',
    'user-whole-body-active',
    'user-whole-body',
    'valet-parking-active',
    'valet-parking',
    'vehicle-signal-active',
    'vehicle-signal',
    'vehicle-wi-fi-1-active',
    'vehicle-wi-fi-1',
    'vehicle-wi-fi-2-active',
    'vehicle-wi-fi-2',
    'vehicle-wi-fi-3-active',
    'vehicle-wi-fi-3',
    'vehicle-wi-fi-4-active',
    'vehicle-wi-fi-4',
    'velocity-active',
    'velocity-alert-active',
    'velocity-alert',
    'velocity',
    'video-active',
    'video-call-active',
    'video-call',
    'video',
    'view-360-active',
    'view-360',
    'vimeo',
    'voice-call-1-active',
    'voice-call-1',
    'voice-call-2-active',
    'voice-call-2',
    'voice-call-3-active',
    'voice-call-3',
    'voice-call-active',
    'voice-call',
    'walk-active',
    'walk',
    'wallbox-active',
    'wallbox',
    'warranty-active',
    'warranty',
    'weblink-active',
    'weblink',
    'wechat',
    'weibo',
    'whatsapp',
    'work-active',
    'work',
    'x',
    'xing',
    'yelp',
    'youku',
    'youtube',
    'zero-plastic-active',
    'zero-plastic',
    'zhihu',
];
//# sourceMappingURL=_SvgIconNames.generated.mjs.mjs.map